import React, { useState } from 'react';

/**
 * Reusable background component matching the landing page aesthetic
 * Includes grain texture, twinkling stars, and sparkle stars
 */
const Background: React.FC = () => {
  // Generate random star positions on mount (matching landing page)
  const [starPositions] = useState(() => {
    return Array.from({ length: 60 }, () => ({
      left: Math.random() * 100,
      top: Math.random() * 100,
      delay: Math.random() * 3,
      duration: 2 + Math.random() * 2
    }));
  });

  // Generate random sparkle positions (matching landing page)
  const [sparklePositions] = useState(() => {
    return Array.from({ length: 10 }, () => ({
      left: Math.random() * 100,
      top: Math.random() * 100,
      delay: Math.random() * 3,
      duration: 2.5 + Math.random() * 2.5,
      size: 3 + Math.random() * 2 // 3-5px
    }));
  });

  return (
    <>
      {/* Grain texture overlay - exact match to landing page */}
      <div 
        className="fixed inset-0 opacity-40 pointer-events-none z-0" 
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 400 400' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='3.5' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`,
          backgroundRepeat: 'repeat',
          backgroundSize: '200px 200px'
        }}
      />

      {/* Twinkling stars background - exact match to landing page */}
      <div className="fixed inset-0 pointer-events-none z-0">
        {starPositions.map((star, i) => (
          <div
            key={i}
            className="absolute w-1 h-1 bg-white rounded-full animate-twinkle"
            style={{
              left: `${star.left}%`,
              top: `${star.top}%`,
              animationDelay: `${star.delay}s`,
              animationDuration: `${star.duration}s`
            }}
          />
        ))}
        {/* Sparkle-shaped stars - exact match to landing page */}
        {sparklePositions.map((sparkle, i) => (
          <div
            key={`sparkle-${i}`}
            className="absolute animate-twinkle"
            style={{
              left: `${sparkle.left}%`,
              top: `${sparkle.top}%`,
              animationDelay: `${sparkle.delay}s`,
              animationDuration: `${sparkle.duration}s`,
              width: `${sparkle.size}px`,
              height: `${sparkle.size}px`,
            }}
          >
            <svg
              width={sparkle.size}
              height={sparkle.size}
              viewBox="0 0 12 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="w-full h-full"
            >
              <path
                d="M6 0L6.5 4.5L11 5L6.5 5.5L6 10L5.5 5.5L1 5L5.5 4.5L6 0Z"
                fill="white"
                opacity="0.9"
              />
            </svg>
          </div>
        ))}
      </div>
    </>
  );
};

export default Background;

